import React from "react";
import motorBike from "../../../../../common/images/Motorbike.svg";
import { useSelector } from "react-redux";
import { DeliveryIcon, DineInIcon, TakeawayIcon } from "../../../../../utils/svg";

const ORDER_TYPE_CONFIG = {
	pickup: {
		icon: TakeawayIcon,
		label: "Self Pickup",
	},
	delivery: {
		icon: DeliveryIcon,
		label: "Delivery",
	},
	"dine in": {
		icon: DineInIcon,
		label: "Dine in",
	},
};

const DetailStore = () => {
	const { detail } = useSelector((store) => store?.order);

	const outlet = detail?.orderItems?.[0];
	const data = detail?.request_post_datas;
	const orderType = detail?.orderType?.toLowerCase();

	const config = ORDER_TYPE_CONFIG[orderType];
	const Icon = config?.icon;

	return (
		<div className="flex my-5">
			<div className="bg-white p-3 rounded-md shadow-md flex flex-col justify-center">
				{Icon && <Icon className="h-6 w-auto" />}
				<div className="text-xxs text-gray-600">{config?.label}</div>
			</div>

			<div className="pl-3">
				<h3 className="text-base font-semibold">{outlet?.storeName}</h3>
				<p className="text-xs font-normal">Makanan dan Minuman</p>

				{orderType === "delivery" && (
					<div className="flex gap-1 items-center mt-1">
						<img src={motorBike} alt="Motorbike" />
						<p className="text-xs font-semibold">
							{data?.deliveryPartner?.distance} km
						</p>
					</div>
				)}
			</div>
		</div>
	);
};

export default DetailStore;